import { useTranslation } from "react-i18next";

export default function SuspenseFallback() {
  const { t } = useTranslation();
  return <span>{t("common.loadingText")}</span>;
}
